export default "__VITE_ASSET__EyVcmqBc__"